<div class="application-menu-wrapper" soho-busyindicator blockUI="true" displayDelay="-1">
    <div class="application-menu-header" [ngClass]="{'lm-do-not-apply-color': !applyColorToMenu }">
        <div class="application-menu-actor-info-container ">
            <div class="col1">
                <span *ngIf="noActorUrl() && !anonymousUser" class="actor-initials {{actorInitialsColorClass}}">{{actorInitials}}</span>
                <img *ngIf="!noActorUrl()" class="icon avatar" [src]="actorUrl" alt=""/>
            </div>
            <div class="col2">
                <!-- anonymous -->
                <ng-container *ngIf="anonymousUser">
                    <button *ngIf="clientLogin" soho-button="btn" id="ClientLoginSignIn_button" (click)="openLoginWindow()">{{ 'SignIn' | translate }}</button>
                    <button *ngIf="!clientLogin" soho-button="btn" id="SignIn_button" (click)="openSecurityLink(signInLink)">{{ 'SignIn' | translate }}</button>
                    <button *ngIf="hasRegisterLink" soho-button="btn" id="Register_button" (click)="openLink(registerLink)">{{ 'Register' | translate }}</button>
                </ng-container>

                <!-- NOT anonymous -->
                <ng-container *ngIf="!anonymousUser && !isPasswordReset">
                    <button *ngIf="!mingleMode && !insideInforGo" soho-button="btn"
                            id="Logout_button"
                            data-automation-id="lm-appmenu-logout-button"
                            (click)="openSecurityLink(signOutLink)">
                        {{ 'SignOut' | translate }}
                    </button>

                    <ng-container *ngIf="notificationsButton && notificationsButton.url">
                        <button soho-button="icon"
                                id="{{notificationsButton.id}}"
                                attr.data-automation-id="{{notificationsButton.automationId}}"
                                soho-tooltip content="{{ notificationsButton.label }}"
                                [icon]="notificationsButton.icon"
                                (click)="openNotificationsLink(notificationsButton.url)"
                        >
                            <span [ngClass]="{'red-dot' : displayRedDot }"></span>
                            {{notificationsButton.label}}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="printFilesButton && printFilesButton.url">
                        <button soho-button="icon"
                                id="{{printFilesButton.id}}"
                                attr.data-automation-id="{{printFilesButton.automationId}}"
                                soho-tooltip content="{{ printFilesButton.label }}"
                                [icon]="printFilesButton.icon"
                                (click)="openLink(printFilesButton.url)"
                        >
                            {{printFilesButton.label}}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="inbasketButton && inbasketButton.url">
                        <button soho-button="icon"
                                id="{{inbasketButton.id}}"
                                attr.data-automation-id="{{inbasketButton.automationId}}"
                                soho-tooltip content="{{ inbasketButton.label }}"
                                [icon]="inbasketButton.icon"
                                (click)="openLink(inbasketButton.url)"
                        >
                            {{inbasketButton.label}}
                        </button>
                    </ng-container>

                    <button soho-button="icon"
                            id="lm-application-menu-settings-btn"
                            data-automation-id="lm-appmenu-settings-menu-button"
                            class="lm-application-menu-settings-btn"
                            soho-tooltip content="{{ 'More' | translate }}"
                            [icon]="'more'"
                            (click)="onToggleActionMenu()">
                    </button>

                    <ng-container *ngIf="displayMenuGuide">
                        <div #SettingsGuide
                             data-automation-id="lm-appmenu-settings-guide"
                             class="lm-appmenu-menu-guide popdown bottom visible"
                        >
                            <div class="arrow"></div>
                            <div class="popdown-contents">
                                <div class="widget">
                                    <div class="widget-header">
                                        <h3>{{ 'SettingsMenuGuideHeader' | translate }}</h3>
                                    </div>
                                    <div class="widget-content">
                                        <p>{{ 'SettingsMenuGuideContent' | translate }}</p>
                                    </div>
                                    <div class="widget-footer">
                                        <button soho-button="primary"
                                                (click)="dismissSettingsGuide()">{{ 'GotIt' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div #ActionMenu
                         id="lm-application-action-menu"
                         data-automation-id="lm-appmenu-settings-menu"
                         class="lm-application-action-menu popupmenu-wrapper bottom"
                    >
                        <div class="arrow"></div>
                        <ul class="popupmenu has-icons">
                            <ng-container *ngFor="let button of applicationMenuButtons" >
                                <li *ngIf="button.url" id="{{button.id}}" (click)="openLink(button.url)" (click)="closeActionMenu()">
                                    <a href="javascript:void(0);" role="menuitem" tabindex="-1"
                                       attr.data-automation-id="{{button.automationId}}"
                                    >
                                        <svg *ngIf="button.icon" soho-icon icon="{{button.icon}}"></svg>
                                        {{button.label}}
                                    </a>
                                </li>
                            </ng-container>

                            <ng-container *ngIf="!hasChangePasswordLink &&
                                !showProxy &&
                                !allowSetAsOfDate &&
                                !enableUserContextMenu; else ShowSeparator">
                            </ng-container>
                            <ng-template #ShowSeparator>
                                <li *ngIf="applicationMenuButtons.length > 0" class="separator"></li>
                            </ng-template>

                            <li *ngIf="createReportButton" soho-popupmenu-item
                                id="{{createReportButton.id}}"
                                (click)="runCreateReport()"
                                (click)="closeActionMenu()"
                            >
                                <a href="javascript:void(0);" role="menuitem" attr.data-automation-id="{{createReportButton.automationId}}" tabindex="-1">
                                    {{createReportButton.label}}
                                </a>
                            </li>

                            <li *ngIf="hasChangePasswordLink" soho-popupmenu-item id="ChangePassword_button" (click)="openChangePasswordWindow()" (click)="closeActionMenu()">
                                <a href="javascript:void(0);" role="menuitem" data-automation-id="lm-appmenu-change-password-button" tabindex="-1">
                                    {{ 'ChangePassword' | translate }}
                                </a>
                            </li>
                            <li *ngIf="showProxy" soho-popupmenu-item id="Proxy_button" (click)="openProxyPage()" (click)="closeActionMenu()">
                                <a href="javascript:void(0);" role="menuitem" data-automation-id="lm-appmenu-proxy-button" tabindex="-1">
                                    {{ 'Proxy' | translate }}
                                </a>
                            </li>
                            <li *ngIf="allowSetAsOfDate" soho-popupmenu-item (click)="openSetAsOfDateDialog()">
                                <a href="javascript:void(0);" role="menuitem" data-automation-id="lm-appmenu-set-as-of-date-button" tabindex="-1">
                                    {{ 'AsOfDateLabel' | translate }}
                                </a>
                            </li>
                            <li *ngIf="enableUserContextMenu" soho-popupmenu-item (click)="openSetUserContextDialog()">
                                <a href="javascript:void(0);" data-automation-id="lm-appmenu-user-context-menu-button">
                                    {{ 'ActorContextMenuLabel' | translate }}
                                </a>
                            </li>

                            <ng-container *ngIf="!hasChangePasswordLink">
                                <li *ngIf="applicationMenuButtons.length > 0" class="separator"></li>

                                <li id="Settings_button" (click)="openUserSettingsDialog()" (click)="closeActionMenu()">
                                    <a href="javascript:void(0);" role="menuitem" tabindex="-1" data-automation-id="lm-appmenu-settings-button">
                                        <svg soho-icon icon="settings"></svg>{{ 'Settings' | translate }}
                                    </a>
                                </li>
                                <li soho-popupmenu-item id="About_button" (click)="openLink(aboutLink)" (click)="closeActionMenu()">
                                    <a href="javascript:void(0);" role="menuitem" tabindex="-1" data-automation-id="lm-appmenu-about-button">
                                        <svg soho-icon icon="info-linear"></svg>{{ 'About' | translate }}
                                    </a>
                                </li>
                                <li *ngIf="appHelpLink" soho-popupmenu-item id="Help_button" (click)="openHelpLink()" (click)="closeActionMenu()">
                                    <a href="javascript:void(0);" role="menuitem" tabindex="-1" data-automation-id="lm-appmenu-help-button">
                                        <svg soho-icon icon="help"></svg>{{ 'Help' | translate }}
                                    </a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </div>
        <span *ngIf="!anonymousUser" class="app-message">{{ 'Welcome' | translate }},</span>
        <h2 *ngIf="!anonymousUser" data-automation-id="lm-appmenu-actor-name" class="actor-name">{{actorName}}</h2>

        <!-- MENU SEARCH FIELD -->
        <div *ngIf="showSearch && !anonymousUser" soho-searchfield-wrapper>
            <label class="audible" for="application-menu-searchfield">{{ 'Search' | translate }}</label>
            <input #SearchField
                    autofocus
                    id="application-menu-searchfield"
                    data-automation-id="lm-appmenu-searchfield"
                    data-options="{'autocompleteAttribute': 'false'}"
                    soho-toolbar-searchfield
                    placeholder="{{ 'Search' | translate }}"
                    [(ngModel)]="model.searchFieldValue"
                    [collapsibleOnMobile]="true"
                    [clearable]="true"
                    (ngModelChange)="autoSearchMenu($event)"
                    (keydown.enter)="fireMenuSearchEvent($event)"
                    (cleared)="fireClearSearchEvent($event)"
            />
        </div>
    </div>

    <div class="application-menu-content">

        <div class="role-switcher-container" lm-new-theme-hover>
            <ng-container *ngIf="(roleSwitcher && filteredWebAppSpecs.length > 0) || (menuItemSpecs && filteredWebAppSpecs.length > noCasualApps); else SingleWebApp">
                <a #AppMenuSwitcher
                   id="{{webAppSwitcherButtonId}}"
                   data-automation-id="lm-appmenu-webapp-menu-open-button"
                   class="application-menu-switcher-trigger hide-focus"
                   (click)="onAppMenuSwitcherClicked($event)"
                   soho-tooltip content="{{ 'SwitchApplication' | translate }}" [attachToBody]="false"
                >
                    <span class="application-menu-switcher-trigger-container">
                        <span id="web-app-title-multiple" data-automation-id="lm-appmenu-web-app-title-multiple" class="lm-web-app-title">{{ webAppTitle }}</span>

                    <ng-container *ngIf="isClassicTheme; else IsNewTheme">
                        <svg *ngIf="!rolesPaneIsOpen" soho-icon icon="caret-down"></svg>
                    </ng-container>

                    <ng-template #IsNewTheme>
                        <svg *ngIf="!rolesPaneIsOpen"
                             soho-icon icon="expand-all"
                             data-automation-id="lm-appmenu-web-app-icon"
                        ></svg>
                    </ng-template>
                </span>
                </a>

                <ng-container *ngIf="displayMenuGuide">
                    <div #AppSwitcherGuide
                         data-automation-id="lm-appmenu-appSwitcher-guide"
                         class="lm-appmenu-menu-guide popdown bottom visible"
                         style="display:none; right:5px"
                    >
                        <div class="arrow"></div>
                        <div class="popdown-contents">
                            <div class="widget">
                                <div class="widget-header">
                                    <h3>{{ 'RoleSwitcherMenuGuideHeader' | translate }}</h3>
                                </div>
                                <div class="widget-content">
                                    <p>{{ 'RoleSwitcherMenuGuideContent' | translate }}</p>
                                </div>
                                <div class="widget-footer">
                                    <button soho-button="primary"
                                            (click)="dismissAppSwitcherGuide()">{{ 'GotIt' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #SingleWebApp>
                <div class="role-switcher-container lm-is-single-webapp">
                    <div class="application-menu-switcher-trigger">
                        <span id="web-app-title-single" class="lm-web-app-title">{{ webAppTitle }}</span>
                    </div>
                </div>
            </ng-template>
        </div>


        <div #AppMenuContent>
            <ng-container *ngIf="isPasswordReset">
                <div class="accordion panel inverse" data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}">
                    <div class="accordion-header"><a><span>{{ 'ResetPassword' | translate }}</span></a></div>
                </div>
            </ng-container>

            <ng-container *ngIf="!isPasswordReset">
                <div class="accordion panel inverse" data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}">
                    <ng-container *ngIf="appSwitcher === 'casual'">
                        <ng-container *ngIf="menuItemSpecs">
                            <lm-application-menu-submenu
                                    [menuItemSpecs]="menuItemSpecs"
                                    [inSearchResultsMenu]="false"
                                    (menuLoaded)="onMenuLoaded($event)"
                            ></lm-application-menu-submenu>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- role switcher -->
    <div #ExpandablePane class="lm-roles-pane" [@paneDisplay]="rolesPaneIsOpen ? 'block' : 'none'">
        <div class="lm-roles-header">
            <h2 class="lm-web-app-title">{{ webAppTitle }}</h2>
            <button
                    id="close-role-panel"
                    data-automation-id="lm-appmenu-webapp-menu-close-button"
                    type="button"
                    class="btn"
                    (click)="onAppMenuSwitcherClicked($event)"
            >
                <span aria-hidden="true">Close Role Switcher</span>
                <svg soho-icon icon="close"></svg>
            </button>
        </div>
        <div class="panel inverse">
            <div *ngFor="let menuItem of filteredWebAppSpecs" class="accordion-header hide-focus">
                <a  href="javascript:void(0);"
                    (click)="onSelectRole($event)"
                    (contextmenu)="onRoleRightClick($event, menuItem)"
                    attr.id="{{webAppId(menuItem.webAppName)}}"
                    attr.data-automation-id=lm-{{menuItem.webAppName}}-webapp
                    attr.web-app-name="{{menuItem.webAppName}}"
                    attr.navigation-menu-url="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                    title="{{menuItem?.webAppTitle || menuItem?.name}}"
                ><span>{{menuItem?.webAppTitle || menuItem?.name}}</span></a>
            </div>
        </div>
    </div>
</div>

<div #UserSettingsDialog>
    <!-- dialog placeholder used to display user settings -->
</div>

<div #LoginDialog>
    <!-- dialog placeholder used to display login screen -->
</div>

<div #AccessDeniedDialog>
    <!-- dialog placeholder used to display access denied error -->
</div>

<div #ChangePasswordDialog>
    <!-- dialog placeholder used to display change password screen -->
</div>

<div #DrillbackActionFormDialog>
    <!-- dialog placeholder used to display a drillback for an action form -->
</div>

<div #ReportPersonalizationDialog>
    <!-- dialog placeholder used to display a report personalization dialog -->
</div>

<div #SetAsOfDateDialog>
    <!-- dialog placeholder used to display Set As of Date dialog -->
</div>

<div #UserContextDialog>
    <!-- dialog placeholder used to display User Context dialog -->
</div>

<div #menuFormDialog>
    <!-- dialog placeholder used to display action form from menu -->
</div>